import React from 'react'
import style from "./Configurator.module.css"

const Configurator = () => {
  return (
    <div className={style.configurator}>
      <div></div>
      
    </div>
  )
}

export default Configurator